import { createSupabaseEdgeFetch } from '@nexus/ari-lib/api/supabase-edge-fetch';
import { getAccessToken, resyncSession } from '@nexus/supabase';

import { getSupabaseFunctionRegion, getSupabaseUrl } from '../config/global';

export const documentsEdgeFetch = createSupabaseEdgeFetch({
  baseUrl: `${getSupabaseUrl()}/functions/v1/root/documents`,
  getToken: async () => {
    const token = await getAccessToken();
    if (!token) throw new Error('No authenticated session');
    return token;
  },
  refreshToken: resyncSession,
  region: getSupabaseFunctionRegion(),
});
